<script>
import Settings from '@/settings';

export default {
  data() {
    return {
      resizeListener: null,
      allowedBreakpoints: [],
      viewPort: null
    };
  },
  created() {
    this.checkWidth();
    this.resizeListener = window.addEventListener('resize', () => this.checkWidth());
    this.$on('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.resizeListener);
    });
  },
  methods: {
    checkWidth() {
      let breakpoints = this.allowedBreakpoints.length ? this.allowedBreakpoints : Object.keys(Settings.breakpoints);
      let viewPort = null;

      breakpoints.some((point, index) => {
        viewPort = point;

        if (window.innerWidth < Settings.breakpoints[point])
          return true;
      });

      this.viewPort = viewPort;
    }
  }
}
</script>